import React, { Fragment, useCallback } from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  TextInput,
  TopToolbar,
  CreateButton,
  ReferenceField,
} from "react-admin";
import { Route, useHistory } from "react-router-dom";
import { Drawer } from "@material-ui/core";

import CityCreate from "./CityCreate";
import CityEdit from "./CityEdit";

import { Roles } from "../../utils/enums";
import { FormGeneral } from "../../styles/FormGeneral";

const Filters = (props) => (
  <Filter {...props} variant="outlined">
    <TextInput label="Buscar por nombre" source="name" resettable alwaysOn />
  </Filter>
);

const Actions = ({ permissions, basePath }) => (
  <TopToolbar>
    {permissions === Roles.admin && <CreateButton basePath={basePath} />}
  </TopToolbar>
);

const CityList = ({ permissions, ...props }) => {
  const classes = FormGeneral();
  const history = useHistory();

  const handleClose = useCallback(() => {
    history.push("/cities");
  }, [history]);

  return (
    <Fragment>
      <List
        filters={<Filters />}
        actions={<Actions permissions={permissions} />}
        bulkActionButtons={permissions === Roles.admin ? undefined : false}
        {...props}
      >
        <Datagrid>
          <TextField source="id" />
          <ReferenceField source="provinceId" reference="provinces">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="name" />
          {permissions === Roles.admin && <EditButton />}
        </Datagrid>
      </List>
      {permissions === Roles.admin && (
        <Route path="/cities/create">
          {({ match }) => (
            <Drawer
              open={!!match}
              anchor="right"
              onClose={handleClose}
              classes={{ root: classes.drawerIndex }}
            >
              <CityCreate
                className={classes.drawerContent}
                onCancel={handleClose}
                {...props}
              />
            </Drawer>
          )}
        </Route>
      )}
      {permissions === Roles.admin && (
        <Route path="/cities/:id">
          {({ match }) => {
            const isMatch = !!(
              match &&
              match.params &&
              match.params.id !== "create"
            );

            return (
              <Drawer
                open={isMatch}
                anchor="right"
                onClose={handleClose}
                classes={{ root: classes.drawerIndex }}
              >
                {isMatch ? (
                  <CityEdit
                    className={classes.drawerContent}
                    id={match.params.id}
                    onCancel={handleClose}
                    {...props}
                  />
                ) : (
                  <div className={classes.drawerContent} />
                )}
              </Drawer>
            );
          }}
        </Route>
      )}
    </Fragment>
  );
};

export default CityList;
